import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { CustomButton, OptionalButtons } from './WrongPageLayout/styled';

import { SomethingWentWrongIcon } from './styled';
import WrongPageLayout from './WrongPageLayout';

interface ISomethingWrong {
  onReset?: () => void;
}

const SomethingWrong: React.FC<ISomethingWrong> = ({ onReset }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onBack = () => {
    if (onReset) {
      onReset();
    } else {
      navigate(-1);
    }
  };

  const onGoMainPage = useCallback(() => {
    navigate('/');
    onReset?.();
  }, []);

  return (
    <WrongPageLayout
      icon={<SomethingWentWrongIcon />}
      subtitle={t('somethingWrong.subtitle')}
      title={t('somethingWrong.title')}
    >
      <OptionalButtons $isDouble>
        <CustomButton onClick={onBack} variant='primary'>
          {t('somethingWrong.button')}
        </CustomButton>
        <CustomButton onClick={onGoMainPage} variant='primary'>
          {t('common.goHomeButton')}
        </CustomButton>
      </OptionalButtons>
    </WrongPageLayout>
  );
};

export default SomethingWrong;
